import { render, staticRenderFns } from "./CustomerTypeAdd.vue?vue&type=template&id=61c7c97c"
import script from "./CustomerTypeAdd.vue?vue&type=script&lang=js"
export * from "./CustomerTypeAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports